import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReminderCrudService } from './reminder-crud/reminder-crud.service';
import { ReminderService } from './reminder-service/reminder.service';
import { ReminderManagerComponent } from './reminder-manager/reminder-manager.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgbTabsetModule, NgbDatepickerModule, NgbTimepickerModule, NgbDateAdapter, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { QmPipesModule } from '../components/qm-pipes/qm-pipes.module';
import { checkUIPermissionsFactory } from '../auth/ui-permissions-factory';
import { AuthService } from '../auth/auth.service';
import { HttpClient } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    NgbTabsetModule,
    NgbTimepickerModule,
    NgbDatepickerModule,
    NgbTooltipModule,
    FormsModule,
    QmPipesModule
  ],
  providers: [
    {
      provide: ReminderCrudService,
      deps: [HttpClient, AuthService],
      useFactory: checkUIPermissionsFactory.bind(null, ReminderCrudService, ['reminders'])
    },
    ReminderService
  ],
  declarations: [
    ReminderManagerComponent
  ],
  exports: [
    ReminderManagerComponent
  ]
})
export class ReminderModule { }
